module.exports = "/images/AssignAPackage_1of2.jpg";